import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    const processAuth = async () => {
      try {
        const response = await axios.post(`${API}/auth/google`, { session_id: sessionId }, { withCredentials: true });
        const userData = response.data;
        login(userData, userData.token);
        navigate('/dashboard', { state: { user: userData } });
      } catch (error) {
        console.error('Google auth failed:', error);
        navigate('/login');
      }
    };
    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#040F1E] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-4 border-[#00C4B4] border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-white/70 font-dm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
